module.exports = __webpack_public_path__ + "img/solution14.73aaa0c0.png";